import { Typography } from "@mui/material";
import { saveAs } from "file-saver";

import { Box, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { tokens } from "../../theme";
import GreetingHeader from "../../components/GreetingHeader";
import CustomButton from "../../components/CustomButton";
import Grid from "@mui/material/Unstable_Grid2";
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
  getFromLocalStorageJsonObject,
} from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useAtom } from "jotai";
import * as CONSTANT from "../../constants/Constant";
import isEmptyArray from "lodash/isEmpty";
import SearchBarFilter from "../../components/SearchBarFilter";

import {
  selectedItems,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  LOADING_TIMELINE,
  SOME_ERROR_OCCURRED,
  ERROR,
} from "../../constants/Strings";
import DebugLog, { printLog } from "../../utils/DebugLog";
import {
  LOGIN_ID,
  LOGIN_RESPONSE,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import {
  deleteEarMarkDetails,
  getEarMarkDetails,
  getEarMarkTimelineDetails,
  getEarmarkActivityDetails,
  getEarmarkDetailsSummaryTopBarItems,
  updateEarMarkDetails,
  downloadEarmarkReports,
} from "../../services/ApiService";
import { useNavigate } from "react-router-dom";
import { earmarksDetailsColumnHeader } from "../../components/ColumnHeader";
import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import UserActivityInfo from "../../components/UserActivity";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import AddEarmarkDialogInput from "./AddEarmarkDialog";
import EarmarkHighlightStats from "../../components/EarmarkHighlightedStats";
import SaveAndRemoveEarmarkDialog from "./SaveAndRemoveEarmarkDialog";
import { formatPrice } from "../../utils/PriceFormatter";
import { DownloadFileWithDatePickerSelectionDialog } from "../../components/DownloadFileWithDatePickerSelectionDialog";

// Filter Configurations to be passed to SearchBarFilter in SectionHeader
const filterProps = [
  {
      keyValue: 'Account Name',
      displayName: 'Name',
      paramName: 'accountName',
      isDateFilter: false,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
  {
    keyValue: 'Date',
    displayName: 'Date',
    paramName: 'transactionDate',
    isDateFilter: true,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
  {
    keyValue: 'Account Code',
    displayName: 'Code',
    paramName: 'accountCode',
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },  
  {
    keyValue: 'Reason',
    displayName: 'Reason',
    paramName: 'reason',
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
  {
    keyValue: 'Amount',
    displayName: 'Earmark',
    paramName: 'earmarkAmount',
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
];

export function EarmarkScreen() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const isNetworkConnectionAvailable = UseOnlineStatus();

  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  const [earmarkDetails, setearmarkDetails] = useState([]);
  const [earmarkTimelineDetails, setearmarkTimelineDetails] = useState([]);
  const [earmarkActivityDetails, setearmarkActivityDetails] = useState([]);
  const [earmarkDetailsSummary, setearmarkDetailsSummary] = useState([]);
  const [totalAccounts, setTotalAccounts] = useState(0);
  const [totalEarmarkAmount, setTotalEarmarkAmount] = useState("0.00");

  const [selectedDateRange, setSelectedDateRange] = useState(
    CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS
  );
  // const [fromDate, setFromDate] = useState(new Date(toDate.setMonth(toDate.getMonth() - 3)));

  const [open, setOpen] = useState(false);
  const [openSaveAndRemoveDialog, setOpenSaveAndRemoveDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);

  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  // pagination for Earmark
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(15);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  // pagination for Activity
  const [activityPageSize, setActivityPageSize] = useState(15);
  const [activityCurrentPage, setActivityCurrentPage] = useState(0);
  const [activityTotalNoOfPages, setActivityTotalNoOfPages] = useState(0);

  // pagination for Timeline
  const [timelinePageSize, setTimelinePageSize] = useState(8);
  const [timelineCurrentPage, setTimelineCurrentPage] = useState(0);
  const [timelineTotalNoOfPages, setTimelineTotalNoOfPages] = useState(0);

  // filter and search
  const [selectedFilter, setSelectedFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [downloadButtonVisible, setDownlaodButton] = useState(false);
  const [addNewButtonVisible, setAddNewButton] = useState(false);
  const [editAllowed, setEditAllowed] = useState(false);

  const [downloadFileDialogOpen, setDownloadFileDialogOpen] = useState(false);
  const [clickedButtonType, setClickedButtonType] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const [reset, setReset] = useState(0);

  // sort model
  const [sortModel, setSortModel] = useState([]);

  // sorting handling 
  useEffect(() => {
    requestEarMarkDetailsData(
      paginationModel.page, 
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  }, [sortModel]);

  useEffect(() => {
    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, rowsPerPage]);

  useEffect(() => {
    getEarmarksDetailsSummary();

    requestEarMarkDetailsData(
      paginationModel.page, 
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );

    getActivityDetails(activityCurrentPage, selectedDateRange);

    updateButtonVisibility();
  }, []);

  const updateButtonVisibility = () => {
    const sessionId = getFromLocalStorage(SESSION_ID);
    try {
      if (sessionId !== "") {
        const userDetails = getFromLocalStorageJsonObject(LOGIN_RESPONSE);

        let adjustments = [];

        if (!isEmptyArray(userDetails)) {
          let menuListSize = userDetails.length;
          if (menuListSize != null && menuListSize > 0) {
            userDetails.forEach((item, index) => {
              if (item.menuListName === "Adjustment") {
                adjustments = [...item.menuItem];
              }
            });

            adjustments.forEach((itemA, index) => {
              if (itemA.menuName === "Earmark") {
                const actionButtonList = [...itemA.actionButton];
                DebugLog(
                  "actionButtonList from sidebar    " +
                    JSON.stringify(actionButtonList)
                );

                actionButtonList.forEach((items, index) => {
                  if (items.buttonName === "DOWNLOAD") {
                    setDownlaodButton(true);
                  } else if (items.buttonName === "ADD NEW") {
                    setAddNewButton(true);
                  } else if (items.buttonName === "VIEW") {
                    // set view only
                  } else if (items.buttonName === "EDIT") {
                    setEditAllowed(true);
                  }
                });
              }
            });
          }
        }
      }
    } catch (error) {
      DebugLog(error);
    }
  };

  const handleDateRangeChange = (selectedDateRange) => {
    setSelectedDateRange(selectedDateRange);
    getActivityDetails(activityCurrentPage, selectedDateRange);
  };

  // create async funtion to fetch data to refresh page
  const handleRefresh = async () => {
    await Promise.all([
      getEarmarksDetailsSummary(),
      requestEarMarkDetailsData(paginationModel.page, paginationModel.pageSize, selectedFilter, searchQuery),
      getActivityDetails(activityCurrentPage, selectedDateRange),
    ]);
  };

  const handleClose = () => {
    setOpen(false);
    DebugLog("Dialog Closed");
  };

  const handleCloseSaveAndRemoveEarmarkDialog = () => {
    setOpenSaveAndRemoveDialog(false);
    DebugLog("Dialog Closed");
  };

  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });

    requestEarMarkDetailsData(newPage, paginationModel.pageSize, selectedFilter, searchQuery);
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });

    requestEarMarkDetailsData(newPage, paginationModel.pageSize, selectedFilter, searchQuery);
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });

    // call api with new page size and start from page 0.
    // searchAllAccountEarmarkDetails(0, newPageSize);
    requestEarMarkDetailsData(0, newPageSize, selectedFilter, searchQuery);
  };

  const handleActivityPageChange = (newPage) => {
    setActivityCurrentPage(newPage);
    getActivityDetails(newPage, selectedDateRange);
  };

  /********  Timeline Pagination Methods ***********/
  const handleTimelinePageChange = (newPage) => {
    setTimelineCurrentPage(newPage);
    getEarmarkTimelineDetails(newPage, selectedItem);
  };

  function addNewEarmark() {
    navigate(CONSTANT.ADD_DEALER_ROUTE);
    // setOpen(true);
  }
 
  function getEarmarkTimelineDetails(pageNo, params) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_TIMELINE);
        setLoading(true);

        const requestObject = {
          pageNumber: pageNo,
          pageSize: timelinePageSize,
          accountCode: params.code,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EARMARK_DETAILS_AUDIT
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getEarMarkTimelineDetails(requestData)
            .then((response) => {
              const contentData =
                response.data.result.earmarkAuditDetails.content.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
              setearmarkTimelineDetails(contentData);
              setTimelineTotalNoOfPages(
                response.data.result.earmarkAuditDetails.totalPages
              );
              setLoading(false);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  function getEarmarksDetailsSummary() {
    try {
      if (isNetworkConnectionAvailable) {
        // setProgressbarText(LOADING_PLEASE_WAIT);
        // setLoading(true);

        const requestObject = {
          pageNumber: 0,
          pageSize: 100,
        }; 

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EARMARK_DETAILS_SUMMARY
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getEarmarkDetailsSummaryTopBarItems(requestData)
            .then((response) => {
              // const contentData = response.data.result.earmarkDetails.content.map((row) => ({
              //   ...row,
              //   id: generateRandomId(),
              // }));
              // setearmarkDetailsSummary(response.data.result);
              setTotalAccounts(response.data.result.totalAccounts);
              setTotalEarmarkAmount(
                formatPrice(response.data.result.totalEarmarkAmount)
              );
              //setTotalNoOfRows(response.data.result.earmarkDetails.content.length);
              // setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.response != null
                    ? error.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  function getActivityDetails(pageNo, passedDateRange) {
    try {
      if (isNetworkConnectionAvailable) {
        // setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const toDate = new Date();
        let fromDate = new Date();

        switch (passedDateRange) {
          case CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS:
            fromDate.setMonth(toDate.getMonth() - 3);
            break;
          case CONSTANT.ACTIVITY_PERIODS.SIX_MONTHS:
            fromDate.setMonth(toDate.getMonth() - 6);
            break;
          case CONSTANT.ACTIVITY_PERIODS.ONE_YEAR:
            fromDate.setFullYear(toDate.getFullYear() - 1);
            break;
          default:
            fromDate.setMonth(toDate.getMonth() - 3); // default to 3 months if no valid option is selected
        }

        const requestObject = {
          pageNumber: pageNo,
          pageSize: activityPageSize,
          fromDate: fromDate.toISOString(),
          toDate: toDate.toISOString(),
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EARMARK_ACTIVITY_DETAILS_AUDIT
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getEarmarkActivityDetails(requestData)
            .then((response) => {
              const contentData =
                response.data.result.earmarkAuditDetails.content.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
              setearmarkActivityDetails(contentData);
              setActivityTotalNoOfPages(
                response.data.result.earmarkAuditDetails.totalPages
              );
              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.response != null
                    ? error.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  function requestUpdateEarMarkDetailsData(params, earmarkValue, reasonValue) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          accountCode: params.code,
          transactionDate: params.date,
          earmarkAmount: earmarkValue,
          // fromDate: params.fromDate,
          // toDate: params.toDate,
          accountName: params.name,
          reason: reasonValue,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EARMARK_DETAILS_UPDATE
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          updateEarMarkDetails(requestData)
            .then((response) => {
              setLoading(false);
              // refresh the page with new data
              handleRefresh();

              showErrorAlert("SUCCESS", "Earmark updated successfully.");
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.response != null
                    ? error.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  function requestDeleteEarMarkDetailsData(params, earmarkValue, reasonValue) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          accountCode: params.code,
          transactionDate: params.date,
          earmarkAmount: earmarkValue,
          // fromDate: params.fromDate,
          // toDate: params.toDate,
          accountName: params.name,
          reason: reasonValue,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EARMARK_DETAILS_DELETION
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          deleteEarMarkDetails(requestData)
            .then((response) => {
              //setearmarkDetails(contentData);
              setLoading(false);
              // refresh the page with new data
              handleRefresh();

              showErrorAlert("REMOVED", "Earmark removed successfully.");
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.response != null
                    ? error.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  function downloadEarmarkReport(fileType, startDate, endDate) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          fromDate: startDate,
          toDate: endDate,
          // accountCode: params.code,
          // accountName: params.name,
          // reason: params.reason,

          reportTemplate: "EARMARK_REPORT",
          reportFormat: fileType,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EARMARK_REPORT_DOWNLOAD
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          downloadEarmarkReports(requestData)
            .then((response) => {
              setLoading(false);
              // Determine the content type from the headers
              const contentType = response.headers["content-type"];
              const mimeType = contentType.split(";")[0];

              // Handle different content types
              if (mimeType.includes("application/json")) {
                const arrayBuffer = response.data;

                // Function to convert ArrayBuffer to JSON
                const arrayBufferToJson = (buffer) => {
                  const decoder = new TextDecoder("utf-8");
                  const jsonString = decoder.decode(buffer);
                  return JSON.parse(jsonString);
                };

                // Convert the ArrayBuffer to JSON and set it in state
                const jsonObject = arrayBufferToJson(arrayBuffer);

                // setJsonData(jsonObject);
                printLog("JSON data:", JSON.stringify(jsonObject));

                if (jsonObject !== null && jsonObject.responseCode === "-1") {
                  if (
                    jsonObject.displayErrorMessage !== null &&
                    jsonObject.displayErrorMessage !== ""
                  ) {
                    showErrorAlert(ERROR, jsonObject.displayErrorMessage);
                  } else {
                    showErrorAlert(ERROR, jsonObject.errorDescription);
                  }
                }
              } else {
                let blob;
                const currentDate = new Date();
                const day = String(currentDate.getDate()).padStart(2, "0");
                const month = String(currentDate.getMonth() + 1).padStart(
                  2,
                  "0"
                );
                const year = String(currentDate.getFullYear());

                // let filename be "EarmarkReport_YYYY-MM-DD"
                let filename = `EarmarkReport_${year}-${month}-${day}`;
                switch (fileType) {
                  case "CSV":
                    blob = new Blob([response.data], { type: "text/csv" });
                    filename = filename + ".csv";
                    break;
                  case "XLS":
                    blob = new Blob([response.data], {
                      type: "application/vnd.ms-excel",
                    });
                    filename = filename + ".xls";
                    break;
                  case "PDF":
                    blob = new Blob([response.data], {
                      type: "application/pdf",
                    });
                    filename = filename + ".pdf";
                    break;

                  default:
                    throw new Error("Invalid file type");
                }

                // Use FileSaver to save the file
                saveAs(blob, filename);
              }
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  function requestEarMarkDetailsData(
    pageNumber, 
    pageSize,
    selectedFilter, 
    searchQuery
  ) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = createRequestObject(
          pageNumber,
          pageSize,
          selectedFilter,
          searchQuery
        )

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_EARMARKS_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getEarMarkDetails(requestData)
            .then((response) => {
              const contentData =
                response.data.result.earmarkDetails.content.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
              setearmarkDetails(contentData);
              // setTotalNoOfRows(
              //   response.data.result.earmarkDetails.content.length
              // );

              setRowsPerPage(
                response.data.result.earmarkDetails.content.length
              );
              setTotalNoOfRows(
                response.data.result.earmarkDetails.totalElements
              );
              setTotalNoOfPages(response.data.result.earmarkDetails.totalPages);
              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : SOME_ERROR_OCCURRED;

                if (message)
                  showErrorAlert(
                    ERROR,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }
  // Create Request Object for getEarMarkDetails API
  function createRequestObject(pageNumber, pageSize, selectedFilter, filterValue) {
    // Initialize all fields to null
    let requestObject = {
      pageNumber: pageNumber,
      pageSize: pageSize,
      sortOrder: "DESC",
      sortProperty: "TRANSACTION_DATE",
    };

    // Set the appropriate field based on filterCriteria
    if (selectedFilter != null && selectedFilter != undefined && selectedFilter != "" && selectedFilter.paramName != "") {
      if (filterValue != null && filterValue != undefined && filterValue != "") {
        requestObject[selectedFilter] = filterValue;
      }
    }

    // sorting
    try{
      if (sortModel.length > 0) {
        // set sortProperty according to the field
        switch (sortModel[0].field) {
          case "name":
            requestObject.sortProperty = "NAME";
            break;
          case "code":
            requestObject.sortProperty = "DEALER_CODE";
            break;
          case "reason":
            requestObject.sortProperty = "REASON";
            break;
          case "earmark":
            requestObject.sortProperty = "AMOUNT";
            break;
          case "date":
            requestObject.sortProperty = "TRANSACTION_DATE";
            break;
          default:
            break;
        }

        // set the sort order
        requestObject.sortOrder = sortModel[0].sort.toString().toUpperCase();
      } 
    } catch (error) {
      DebugLog("Error in sorting: " + error);
      requestObject.sortProperty = null;
      requestObject.sortOrder = null;
    }

    return requestObject;
  }


  const handleRowClick = (params) => {
    if (editAllowed) {
    setSelectedItem(params.row);
    setOpenSaveAndRemoveDialog(true);
    getEarmarkTimelineDetails(timelineCurrentPage, params.row);
    }
  };

  const handleSearch = (filterParam, searchQuery) => {
    setSelectedFilter(filterParam);
    setSearchQuery(searchQuery);

    setPaginationModel({ pageSize: pageSize, page: 0 });
    requestEarMarkDetailsData(0, pageSize, filterParam, searchQuery);
  }

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.response != null ? error.displayErrorMessage : "Unknown";
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () =>
        navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }

  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
    } catch (error) {
      DebugLog(error);
    }
  }
  useEffect(() => {
    if (content !== null && content !== "") {
      setErrorDialog(true);
    }
  }, [content]); // Dependency array, runs the effect when 'state' changes

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  const openDownloadOptionsDialog = (type) => {
    let title = "";
    if (type === "Download") {
      title = "Download";
    }
    setClickedButtonType(type);
    setReset(0);
    setDialogTitle(title);
    setDownloadFileDialogOpen(true);
  };

  const handleFileDownloadDialogClose = () => {
    setReset(1);
    setDownloadFileDialogOpen(false);
  };

  const handleFileDownloadSubmit = (fileType, type, startDate, endDate) => {
    setReset(1);
    if (type === "Cancel") {
      startDate = null;
      endDate = null;
    } else {
      downloadEarmarkReport(fileType, startDate, endDate);
    }
    setReset(0);
  };

  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}

        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Greetings Header */}
          <Grid container justifyContent="space-between">
            <Grid item>
              <GreetingHeader name={"Earmark"}></GreetingHeader>
            </Grid>

            {/* <Grid item> */}
            <Box position="absolute" right={25} top={60}>
              <SearchBarFilter
                filterProps={filterProps}
                onSearch={handleSearch}
              ></SearchBarFilter>
            </Box>
            {/* </Grid> */}

          </Grid>
          {/* Greetings Header */}

          {/* Highlight Stats */}
          <EarmarkHighlightStats
            highlight0={"Total Dealers"}
            highlightTotal={totalAccounts}
            highlight1={"Total Earmark Amt"}
            highlight1Stat={"RM " + totalEarmarkAmount}
            highlight2={""}
            highlight2Stat={""}
            highlight3={""}
            highlight3Stat={""}
          ></EarmarkHighlightStats>
          {/* Highlight Stats */}

          {/* On Hold Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={3}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            {/* <SectionHeader
              sectionIcon={"../../assets/common/onhold.svg"}
              sectionHeading={"On Hold"}
            ></SectionHeader> */}

            {earmarkDetails.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                sx={{
                  overflow: 'hidden', // Add this to clip the DataGrid's corners
                  "& .MuiDataGrid-root": {
                    border: "none",
                    borderRadius: 'inherit', // Inherit the borderRadius from the Box
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  rows={earmarkDetails}
                  columns={earmarksDetailsColumnHeader}
                  // components={{ Toolbar: CustomToolbar }}
                  // checkboxSelection = {false}
                  selecion
                  pageSize={pageSize}
                  rowCount={totalNoOfRows}
                  // pagination
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[15, 30, 45, 60]} // Include 10 in the options
                  autoHeight
                  onRowClick={handleRowClick}

                  sortModel={sortModel}
                  onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          <AddEarmarkDialogInput open={open} onClose={handleClose} />

          {earmarkDetails.length > 0 ? (
            <Box item mt={2} ml={2}>
              <Typography>
                <span>Jump to page: </span>
                <select
                  value={paginationModel.page + 1}
                  onChange={handlePageJump}
                >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}

          {/* On Hold Section */}

          <SaveAndRemoveEarmarkDialog
            open={openSaveAndRemoveDialog}
            onClose={handleCloseSaveAndRemoveEarmarkDialog}
            onDialogButtonClick={requestUpdateEarMarkDetailsData}
            onDialogRemoveButtonClick={requestDeleteEarMarkDetailsData}
            data={selectedItem}
            earmarkTimeline={earmarkTimelineDetails}
            totalNoOfPages={timelineTotalNoOfPages}
            onPageChange={handleTimelinePageChange}
          />

          {/* Action Buttons */}
          <Grid container mt={1} justifyContent={"flex-end"} pb={3}>
            <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
              {addNewButtonVisible ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnTxt={"ADD NEW"}
                  onClick={addNewEarmark}
                ></CustomButton>
              ) : (
                ""
              )}

              {/* { downloadButtonVisible ? (
                  <DownloadDropdownButton
                    onFileTypeSelected={downloadEarmarkReport}
                  />
                ) : (
                  ""
                )} */}
              {downloadButtonVisible ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img src="../../assets/common/Download.svg" width={22} />
                  }
                  btnTxt={"Download"}
                  onClick={() => openDownloadOptionsDialog("Download")}
                ></CustomButton>
              ) : (
                ""
              )}
            </Stack>
          </Grid>

          {/* Action Buttons */}

          {/* activity list */}
          <Grid container>
            <UserActivityInfo
              type={"EarmarkModule"}
              data={earmarkActivityDetails}
              ondateRangeChange={handleDateRangeChange}
              totalNoOfPages={activityTotalNoOfPages}
              onPageChange={handleActivityPageChange}
            />
            {/* activity list */}
          </Grid>

          {/* Confirmation Dialog */}
          <DownloadFileWithDatePickerSelectionDialog
            open={downloadFileDialogOpen}
            handleClose={handleFileDownloadDialogClose}
            handleSubmit={handleFileDownloadSubmit}
            type={clickedButtonType}
            title={dialogTitle}
            resetIndex={reset}
          />
        </Grid>
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
}
